/* eslint-disable no-undef */

import React, { useEffect, useState } from 'react'
import { func, string } from 'prop-types'
import axios from 'axios'
import { Modal, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'

function EnterCodeModal({
  closeModal,
  setAuthToken,
  context,
}) {
  const [timesResend, setTimesResend] = useState(0)
  const [uuid, setUuid] = useState('')
  const [code, setCode] = useState('')
  const [isVerified, setIsVerified] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')

  function resendEmail() {
    setTimesResend(timesResend + 1)

    axios.post('/two-factor-authentications/resend', { uuid })
      .then((response) => {
        setUuid(response.data.uuid)
        App.events.publish('app:notification:flash:success', 'New email was sent')
      })
      .catch((error) => flashError(error))
  }

  function confirmCode() {
    axios.post('/two-factor-authentications/verify', { uuid, code })
      .then((response) => {
        const { auth_token: authToken, verified, failureMessage } = response.data

        if (window.trackSettingsFormSubmit) {
          window.trackSettingsFormSubmit()
        }

        setAuthToken(authToken || '')
        setIsVerified(verified)
        setErrorMessage(failureMessage || '')

        if (verified) {
          App.events.publish('app:notification:flash:success', 'Verification is successful')
          closeModal()
        }
      })
      .catch((error) => flashError(error))
  }

  function flashError(error) {
    return App.events.publish('app:notification:flash:error', error.response.data.error)
  }

  useEffect(() => {
    axios.post('/two-factor-authentications', { context })
      .then((response) => { setUuid(response.data.uuid) })
      .catch((error) => flashError(error))
  }, [])

  return (
    <Modal
      size="small"
      canClose={false}
      header="Verify your changes"
      headerIcon={<Icon type={['far', 'lock-alt']} />}
      isHeaderSeparated
    >
      <p>
        To protect your account security, we’ve sent you a verification code to your inbox.
        Please enter the verification code to confirm the changes you’re making.
      </p>

      <TextInput
        id="verification-code"
        type="number"
        placeholder="Enter verification code"
        min={0}
        defaultValue={code}
        onChange={({ target: { value } }) => {
          setCode(value)
          setIsVerified(true)
          setErrorMessage('')
        }}
        isErrored={!isVerified}
        message={errorMessage}
      />

      <div className="row">
        <div className="col-auto cgt-mt-20">
          <button
            className="cgt-button cgt-button--secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
        </div>
        <div className="col cgt-mt-20 cgt-legacy-text--align-right">
          <button
            className="cgt-button cgt-button--secondary cgt-mr-10"
            onClick={resendEmail}
            disabled={timesResend >= 3}
          >
            Resend email
          </button>
          <button
            className="cgt-button cgt-button--primary"
            onClick={confirmCode}
            disabled={!code || code.length < 6}
          >
            Confirm
          </button>
        </div>
      </div>

      {timesResend >= 3 && (
        <div className="cgt-legacy-text-tiny cgt-mt-10 cgt-legacy-text--align-center">
          Resend limit reached. Check your promotions or spam folders if you don’t see the email in your primary inbox.
        </div>
      )}
    </Modal>
  )
}

EnterCodeModal.propTypes = {
  closeModal: func.isRequired,
  setAuthToken: func.isRequired,
  context: string.isRequired,
}

export default EnterCodeModal
